<template>
  <div class="copyright_details">
    <my-head></my-head>
    <div class="copyright minH margin-auto">
      <div class="top">
        <div class="crumbs">
          首页 > 版权服务 > {{ zoneName }} >
          <span style="color: #1d2129">当前作品</span>
        </div>
        <div class="buttons">
          <el-button size="small" @click="lamborghini">专区首页</el-button>
          <el-button size="small" @click="previous">上一个</el-button>
          <el-button size="small" @click="nextPage">下一个</el-button>
        </div>
      </div>
      <div class="details" v-if="zoneType == 0">
        <div class="imgs">
          <el-carousel trigger="click" height="800px" interval="5000">
            <el-carousel-item v-for="(item, index) in data.workImages" :key="index">
              <img :src="item.url" alt="" :class="item.width / item.height > 1.138 ? 'imgW' : 'imgH'"
                oncontextmenu="return false" ondragstart="return false">
            </el-carousel-item>

          </el-carousel>
        </div>
        <div class=" describes">
          <el-tabs v-model="activeName">
            <el-tab-pane label="作品详情" name="1">
              <div class="particulars">
                <div class="date">
                  <img src="../assets/copyright_services/02.png" alt="">
                  <span>{{ data.dateSubmit | dateYMDHms }}</span>
                </div>
                <p class="title">{{ data.worksName }}</p>
                <p class="school">{{ data.worksWriter }}</p>
                <p class="describe">{{ data.worksProfile }}</p>
              </div>
            </el-tab-pane>
            <el-tab-pane label="时间信息" name="2">
              <div class="time" oncontextmenu="return false" ondragstart="return false">

                <img src="../assets/copyright_services/01.png" alt="" id="newimage" style="width:450px;height:595px">
                <canvas id="canvas" width="450" height="595" style="display: none;"></canvas>
                <img src="../assets/copyright_services/watermark.png" alt="" class="watermark">

              </div>
            </el-tab-pane>
            <el-tab-pane label="版权信息" name="3">
              <div class="Copyright_information">
                <div class="date">
                  <img src="../assets/copyright_services/02.png" alt="">
                  <span>{{ data.dateSubmit | dateYMDHms }}</span>
                </div>
                <div class="information">
                  <span>作品名称</span>
                  <p>{{ data.worksName }}</p>
                </div>
                <div class="information">
                  <span>作品作者</span>
                  <p>{{ data.worksWriter }}</p>
                </div>
                <div class="information">
                  <span>作品编号</span>
                  <p>{{ data.workNo }}</p>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="details_audio" v-else-if="zoneType == 1">
        <div class="audio">
          <div class="imgs">
            <img class="img1" src='../assets/audio1.png' alt="">
            <img class="img2" src='../assets/audio2.png' alt="">
          </div>
          <div class="content_right">
            <div>{{ data.worksName }}</div>
            <p>{{ data.worksWriter }}</p>
            <span>{{ data.dateSubmit | formatDate3 }} | 编号：{{ data.workNo }}</span>
            <div>
              <audio
                :src="data.voiceUrl ? JSON.parse(data.voiceUrl)[0].url : 'http://test.shsipe.com:8080/property-upload/2024-04-25/2024042514392818289.mp3'"
                style="width: 600px;margin-top: 16px;" controls="controls" controlsList="nodownload"></audio>
            </div>
          </div>
        </div>
        <div class="describes">
          <el-tabs v-model="activeName">
            <el-tab-pane label="作品详情" name="1">
              <div class="particulars">
                <div class="date">
                  <img src="../assets/copyright_services/02.png" alt="">
                  <span>{{ data.dateSubmit | dateYMDHms }}</span>
                </div>
                <p class="title">{{ data.worksName }}</p>
                <p class="school">{{ data.worksWriter }}</p>
                <p class="describe">{{ data.worksProfile }}</p>
              </div>
            </el-tab-pane>
            <el-tab-pane label="时间信息" name="2">
              <div class="particulars">
                <div class="date">
                  <img src="../assets/copyright_services/02.png" alt="">
                  <span>{{ data.dateSubmit | dateYMDHms }}</span>
                </div>
              </div>

              <div class="time" oncontextmenu="return false" ondragstart="return false">

                <img src="../assets/copyright_services/01.png" alt="" id="newimage" style="width:450px;height:595px">
                <canvas id="canvas" width="450" height="595" style="display: none;"></canvas>
                <img src="../assets/copyright_services/watermark.png" alt="" class="watermark">
                <!-- <img src="../assets/copyright_services/01.png" alt="">
                <p class="number">{{ data.workNo }}</p>
                <p class="name">{{ data.worksName }}</p>
                <p class="writer">{{ data.worksWriter }}</p>
                <p class="dateSubmit">{{ data.dateSubmit | dateYMDHms }}</p> -->
              </div>
            </el-tab-pane>
            <el-tab-pane label="版权信息" name="3">
              <div class="Copyright_information">
                <div class="date">
                  <img src="../assets/copyright_services/02.png" alt="">
                  <span>{{ data.dateSubmit | dateYMDHms }}</span>
                </div>
                <div class="list">
                  <div class="information">
                    <span>作品名称</span>
                    <p>{{ data.worksName }}</p>
                  </div>
                  <div class="information">
                    <span>作品作者</span>
                    <p>{{ data.worksWriter }}</p>
                  </div>
                  <div class="information">
                    <span>作品编号</span>
                    <p>{{ data.workNo }}</p>
                  </div>
                </div>

              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>


    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../components/MyHead.vue";
import MyFooter from "../components/MyFooter.vue";
import { getRequest } from "../api/api";
import { formatDate3 } from "../api/util";
import { dateYMDHms } from "../api/filter";
export default {
  components: { MyHead, MyFooter },
  data() {
    return {
      activeName: '1',
      interval: 5000,
      data: {},
      id: null,
      zoneId: null,
      zoneType: null,
      zoneName: null
    };
  },
  watch: {
    // nespage: {
    //   handler() {
    //     this.copyright();
    //   },
    //   deep: true,
    // },
  },
  mounted() {
    if (this.$route.query.id) {
      let id = this.$route.query.id;
      this.id = id
      this.gteList(id)
      this.zoneList()
    }
    if (this.$route.query.zoneId) {
      this.zoneId = this.$route.query.zoneId;
    }
  },
  methods: {
    loadImage(value) {
      console.log(value.target.width)
      console.log(value.target.height)
      console.log(999)
    },

    zoneList() {
      getRequest({ url: "/api/v1/zone?_no_page=0" }).then((res) => {
        if (res.errcode == 200) {
          let obj = res.data.find(t => t.id == this.zoneId)
          this.zoneName = obj.zoneName
          this.zoneType = obj.zoneType
        }
      });
    },

    newImage(workNo, worksName, worksWriter, dateSubmit) {
      // 生成图片
      var imageBox = document.getElementById("newimage")
      var canvas = document.getElementById("canvas")
      var cxt = canvas.getContext("2d")
      var img = new Image()
      img.src = require('../assets/copyright_services/time.png')
      var img2 = new Image()
      img2.src = require('../assets/copyright_services/watermark.png')
      // 图片加载完成，才可处理
      img.onload = () => {
        // 画图(这里画布与图片等宽高)
        cxt.drawImage(img, 0, 0, 450, 595)
        // 设置字体大小
        cxt.font = "14px Microsoft YaHei"
        // 更改字号后，必须重置对齐方式，否则居中麻烦。设置文本的垂直对齐方式
        cxt.textBaseline = 'middle'
        cxt.textAlign = 'left'
        // 距离左边的位置
        var left = canvas.width / 2
        // 距离上边的位置 (图片高-文字距离图片底部的距离)
        var top = canvas.height * 0.14
        // 文字颜色
        cxt.fillStyle = "#000"
        // 文字在画布的位置
        cxt.fillText('作品编号：' + workNo, 100, 214)
        // cxt.font = "14px Microsoft YaHei"
        cxt.fillText('作品名称：' + worksName, 100, 289)
        cxt.fillText('作品作者：' + worksWriter, 100, 372)
        cxt.font = "11px Microsoft YaHei"
        cxt.fillText('签发日期：' + dateSubmit, 240, 516)
        imageBox.src = canvas.toDataURL("image/jpg", 1)
        // this.flag = 1
      }
    },



    // 兰博基尼
    lamborghini() {
      this.$router.back()
      // this.$router.push({
      //   path: "/lamborghini",
      // });
    },


    gteList(id) {
      getRequest({ url: `/api/v1/works/details?id=${id}` }).then((res) => {
        console.warn("什么列表", res);

        if (res.errcode == 200) {
          let data = res.data
          this.data = data;

          this.$nextTick(() => {    // 当 DOM 更新后
            // 在这里你可以访问更新后的 DOM
            this.newImage(data.workNo, data.worksName, data.worksWriter, dateYMDHms(data.dateSubmit))
          });
        }
      });
    },
    // 上一个
    previous() {
      getRequest({ url: `/api/v1/works/previous?id=${this.id}&zoneId=${this.zoneId}` }).then((res) => {
        if (res.data) {
          this.id = res.data
          this.gteList(res.data)
        } else {
          this.$message({
            showClose: true,
            message: '没有上一个了',
            type: 'warning'
          });
        }

      });
    },
    // 下一个
    nextPage() {
      getRequest({ url: `/api/v1/works/nextPage?id=${this.id}&zoneId=${this.zoneId}` }).then((res) => {
        if (res.data) {
          this.id = res.data
          this.gteList(res.data)
        } else {
          this.$message({
            showClose: true,
            message: '没有下一个了',
            type: 'warning'
          });
        }

      });
    }

  },
  //过滤器
  filters: {
    formatDate3(val) {
      return formatDate3(val);
    },
  },
  created() {


  },
  updated() {
    this.$nextTick(() => {    // 当 DOM 更新后
      // 在这里你可以访问更新后的 DOM
      this.newImage(this.data.workNo, this.data.worksName, this.data.worksWriter, dateYMDHms(this.data.dateSubmit))
    });
  }
};
</script>

<style lang="scss">
.copyright_details {


  .copyright {
    min-width: 1380px;
    width: 80%;
    padding-bottom: 48px;

    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 22px;
      margin-bottom: 35px;

      .crumbs {
        margin: 0;
      }
    }

    .details {
      width: 100%;
      height: 800px;
      display: flex;

      .imgs {
        width: 60%;
        height: 100%;
        background: #F2F3F5;
        vertical-align: middle;

        .imgH {
          height: 800px;
          margin: auto;
        }

        .imgW {
          width: 100%;
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%)
        }
      }

      .describes {
        width: 40%;
        padding: 0 30px;
        white-space: pre-wrap;
        overflow-y: auto;

        .particulars,
        .Copyright_information {
          .date {
            display: flex;

            img {
              width: 24px;
            }

            >span {
              font-size: 14px;
              font-weight: 500;
              color: #4080FF;
              line-height: 24px;
              margin-left: 8px;
            }
          }

          .title {
            font-size: 18px;
            font-weight: bold;
            color: #1D2129;
            line-height: 26px;
            margin-top: 16px;
          }

          .school {
            font-size: 14px;
            font-weight: 400;
            color: #4E5969;
            line-height: 22px;
            margin-top: 8px;
          }

          .describe {
            font-size: 16px;
            font-weight: 400;
            color: #000000;
            line-height: 29px;
            margin-top: 10px;
          }
        }

        .time {
          position: relative;
          width: 450px;
          margin: auto;

          .watermark {
            position: absolute;
            top: 260px;
            left: 50px;
            width: 350px;
          }

          .number {
            position: absolute;
            top: 206px;
            left: 193px;
          }

          .name {
            position: absolute;
            top: 283px;
            left: 160px;
          }

          .writer {
            position: absolute;
            top: 367px;
            left: 160px;
          }

          .dateSubmit {
            position: absolute;
            bottom: 71px;
            left: 316px;
            font-size: 13px;
          }

        }

        .Copyright_information {
          .information {
            margin-top: 20px;

            >span {
              font-size: 14px;
              font-weight: 400;
              color: #4E5969;
              line-height: 22px;
            }

            >p {
              font-size: 16px;
              font-weight: 400;
              color: #1D2129;
              line-height: 24px;
            }
          }
        }
      }
    }

    .details_audio {
      width: 100%;

      .audio {
        width: 100%;
        display: flex;

        .imgs {
          // display: flex;
          position: relative;

          .img1 {
            width: 160px;
          }

          .img2 {
            width: 130px;
            position: absolute;
            top: 15px;
            left: 15px;
          }
        }

        .content_right {
          width: 100%;
          margin-left: 30px;

          >div {
            font-size: 14px;
            font-weight: bold;
            color: #1D2129;
            line-height: 26px;
            margin-top: 6px;
          }

          >p {
            font-size: 12px;
            font-weight: 400;
            color: #4E5969;
            line-height: 22px;
          }

          >span {
            font-size: 12px;
            font-weight: 400;
            color: #86909C;
            line-height: 22px;
          }
        }
      }


      .describes {
        width: 100%;
        white-space: pre-wrap;
        overflow-y: auto;

        .particulars,
        .Copyright_information {
          .date {
            display: flex;

            img {
              width: 24px;
            }

            >span {
              font-size: 14px;
              font-weight: 500;
              color: #4080FF;
              line-height: 24px;
              margin-left: 8px;
            }
          }

          .title {
            font-size: 18px;
            font-weight: bold;
            color: #1D2129;
            line-height: 26px;
            margin-top: 16px;
          }

          .school {
            font-size: 14px;
            font-weight: 400;
            color: #4E5969;
            line-height: 22px;
            margin-top: 8px;
          }

          .describe {
            font-size: 16px;
            font-weight: 400;
            color: #000000;
            line-height: 29px;
            margin-top: 10px;
          }
        }

        .time {
          position: relative;
          width: 450px;
          margin-top: 20px;
          // margin: auto;

          .watermark {
            position: absolute;
            top: 260px;
            left: 50px;
            width: 350px;
          }

          .number {
            position: absolute;
            top: 206px;
            left: 193px;
          }

          .name {
            position: absolute;
            top: 283px;
            left: 160px;
          }

          .writer {
            position: absolute;
            top: 367px;
            left: 160px;
          }

          .dateSubmit {
            position: absolute;
            bottom: 71px;
            left: 316px;
            font-size: 13px;
          }

        }

        .Copyright_information {


          .list {
            display: flex;
            justify-content: space-between;
          }

          .information {
            margin-top: 20px;

            >span {
              font-size: 14px;
              font-weight: 400;
              color: #4E5969;
              line-height: 22px;
            }

            >p {
              font-size: 16px;
              font-weight: 400;
              color: #1D2129;
              line-height: 24px;
            }
          }
        }
      }
    }
  }




}



.copyright {
  width: 80%;
  padding-bottom: 48px;
}
</style>
